import { default as indexS02qFtQojpMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/contact/index.vue?macro=true";
import { default as indexf4YbxLeDmkMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/cookies/index.vue?macro=true";
import { default as indexLqSkIHzcrlMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/favorites/index.vue?macro=true";
import { default as indexwJ0p5M7MjkMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/index.vue?macro=true";
import { default as indexOeW5IAQ1TDMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/login/index.vue?macro=true";
import { default as indexdu99trekbEMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/password/forgot/index.vue?macro=true";
import { default as indexqleiPLpKvuMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/password/reset/index.vue?macro=true";
import { default as indexigRG43w7naMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/privacy/index.vue?macro=true";
import { default as indexNVTSjeeyAVMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/profile/index.vue?macro=true";
import { default as indexDsdPQG9obPMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/register/index.vue?macro=true";
import { default as indexSwCVNklnVEMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/reservations/index.vue?macro=true";
import { default as indextrVHHNk879Meta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/restaurant-owner/index.vue?macro=true";
import { default as indexY25OtrWMpiMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/restaurant-owner/register/index.vue?macro=true";
import { default as _91tab_93RkroM08TuZMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/restaurants/[slug]/[tab].vue?macro=true";
import { default as indexYKwt2Bfp6pMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/restaurants/[slug]/index.vue?macro=true";
import { default as index5PAjVnQubDMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/search/index.vue?macro=true";
import { default as indexce6Wc2NNazMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/search/map/index.vue?macro=true";
import { default as indexPNC03xiLrDMeta } from "/codebuild/output/src1962478339/src/kichieats-front/pages/terms/index.vue?macro=true";
import { default as component_45stubQy4nUO5DzVMeta } from "/codebuild/output/src1962478339/src/kichieats-front/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubQy4nUO5DzV } from "/codebuild/output/src1962478339/src/kichieats-front/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "contact",
    path: "/contact",
    meta: indexS02qFtQojpMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/contact/index.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    meta: indexf4YbxLeDmkMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/cookies/index.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    meta: indexLqSkIHzcrlMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/favorites/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexwJ0p5M7MjkMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexOeW5IAQ1TDMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/login/index.vue")
  },
  {
    name: "password-forgot",
    path: "/password/forgot",
    meta: indexdu99trekbEMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/password/forgot/index.vue")
  },
  {
    name: "password-reset",
    path: "/password/reset",
    meta: indexqleiPLpKvuMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/password/reset/index.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: indexigRG43w7naMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/privacy/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexNVTSjeeyAVMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/profile/index.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: indexDsdPQG9obPMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/register/index.vue")
  },
  {
    name: "reservations",
    path: "/reservations",
    meta: indexSwCVNklnVEMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/reservations/index.vue")
  },
  {
    name: "restaurant-owner",
    path: "/restaurant-owner",
    meta: indextrVHHNk879Meta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/restaurant-owner/index.vue")
  },
  {
    name: "restaurant-owner-register",
    path: "/restaurant-owner/register",
    meta: indexY25OtrWMpiMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/restaurant-owner/register/index.vue")
  },
  {
    name: "restaurants-slug-tab",
    path: "/restaurants/:slug()/:tab()",
    meta: _91tab_93RkroM08TuZMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/restaurants/[slug]/[tab].vue")
  },
  {
    name: "restaurants-slug",
    path: "/restaurants/:slug()",
    meta: indexYKwt2Bfp6pMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/restaurants/[slug]/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: index5PAjVnQubDMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/search/index.vue")
  },
  {
    name: "search-map",
    path: "/search/map",
    meta: indexce6Wc2NNazMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/search/map/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexPNC03xiLrDMeta || {},
    component: () => import("/codebuild/output/src1962478339/src/kichieats-front/pages/terms/index.vue")
  },
  {
    name: component_45stubQy4nUO5DzVMeta?.name,
    path: "/restaurants",
    component: component_45stubQy4nUO5DzV
  }
]